import styled from 'styled-components';

/**
 * Controles de orientação Paisagem/Retrato pras telas de espera (NoContent).
 *
 * 2026-06-05 — Renato pediu os mesmos botões do painel (MediaInfo) nas telas
 * "Aguardando conteúdo"/"Aguardando aprovação" pra o operador forçar a
 * orientação manualmente quando a auto-detecção não acerta sozinha.
 *
 * Diferença visual pro painel: aqui os botões ficam SOBRE backgrounds variados
 * (custom backgroundUrl, fundo teal, etc), então usam um fundo escuro
 * semi-opaco + blur pra garantir legibilidade em qualquer tela.
 */
export const OrientationButtons = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 28px;
  justify-content: center;
  flex-wrap: wrap;
`;

export const OrientationButton = styled.button<{ $selected: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 22px;
  border-radius: 10px;
  font-size: 17px;
  font-weight: 600;
  font-family: 'Roboto', sans-serif;
  cursor: pointer;
  transition: all 150ms ease-in-out;
  -webkit-backdrop-filter: blur(4px);
  backdrop-filter: blur(4px);
  background: ${({ $selected }) =>
    $selected
      ? 'linear-gradient(135deg, #2196f3 0%, #1976d2 100%)'
      : 'rgba(0, 0, 0, 0.45)'};
  color: ${({ $selected }) => ($selected ? '#ffffff' : '#e0e0e0')};
  border: 2px solid
    ${({ $selected }) => ($selected ? '#2196f3' : 'rgba(255, 255, 255, 0.25)')};

  &:hover {
    background: ${({ $selected }) =>
      $selected
        ? 'linear-gradient(135deg, #42a5f5 0%, #2196f3 100%)'
        : 'rgba(0, 0, 0, 0.6)'};
    border-color: ${({ $selected }) =>
      $selected ? '#42a5f5' : 'rgba(255, 255, 255, 0.4)'};
  }

  &:focus {
    transform: scale(1.05);
    box-shadow: 0 0 0 4px rgba(79, 195, 247, 0.3);
    outline: none;
  }

  svg {
    width: 22px;
    height: 22px;
    fill: currentColor;
  }
`;

export const AutoBadge = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: #4fc3f7 !important;
  background: rgba(79, 195, 247, 0.15);
  padding: 2px 8px;
  border-radius: 4px;
  margin-left: 4px;
`;
